import ability from './ability'

export const canNavigate = to => to.meta.permission !== undefined
    && ability.can(to.meta.permission.action, to.meta.permission.resource)

export const _ = undefined
